import { render } from "./EmergencyContactList.vue?vue&type=template&id=3e2216c8&ts=true"
import script from "./EmergencyContactList.vue?vue&type=script&lang=ts"
export * from "./EmergencyContactList.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3546012314/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__